// @ts-nocheck
import { createTheme } from '@mui/material/styles';
import {
  primary,
  secondary,
  text,
  error,
  info,
  warning,
  success,
  action,
  common,
  background,
  custom1,
  grey,
  other,
  normalText,
} from 'assets/colors/colors';

const previewTableTheme = createTheme({
  palette: {
    mode: 'light',
    primary,
    secondary,
    text,
    error,
    info,
    warning,
    success,
    custom1,
    action,
    common,
    background,
    grey,
    other,
    divider: 'rgba(0,0,0,0.12)',
    normalText,
  },
  typography: {
    subtitle1: {
      fontWeight: 500,
      color: primary.main,
    },
    subtitle2: {
      fontWeight: 500,
      lineHeight: 1.57,
      letterSpacing: '0.00714em',
    },
  },
  components: {
    MuiTable: {
      styleOverrides: {
        root: {
          borderCollapse: 'collapse',
          marginTop: '16px',
          width: 'auto',
          th: {
            backgroundColor: grey.custom1,
            padding: '8px 12px',
            border: `1px solid ${grey.g200}`,
            fontSize: '14px',
            fontWeight: 500,
            color: primary.main,
          },
          td: {
            border: `1px solid ${grey.g200}`,
            padding: '8px',
            verticalAlign: 'top',
            minWidth: '250px',
            maxWidth: '300px',
          },

          '& .MuiCard-root.MuiPaper-elevation': {
            boxShadow: 'none',
            border: 'none',
          },
        },
      },
    },
  },
});

export default previewTableTheme;
